import { Component } from "preact";
import { Doughnut } from "react-chartjs-2";

export default class DoughnutChart extends Component {
  render() {
    return (
      <Doughnut
        width={this.props.width}
        height={this.props.height}
        data={this.props.data}
        options={{
          elements: {
            arc: {
              borderWidth: 0,
            },
          },
          cutoutPercentage: 60,
          maintainAspectRatio: true,
          legend: {
            display: false,
          },
          tooltips: {
            displayColors: false,
            bodyFontSize: 14,
            bodyFontFamily: "Open Sans",
            titleFontSize: 14,
            titleFontFamily: "Open Sans",
            callbacks: {
              title: (item, data) => data.titles[item[0].index],
              label: (item, data) => data.labels[item.index],
            },
          },
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/doughnutChart/index.js